<template>
  <div class="modal is-active account-type-dialog">
      <div class="modal-background"></div>
      <div class="modal-content">
        <div class="box">
          <h3>עריכת סוג מנוי</h3>
          <div v-if="!message.visible">
            <button class="yoga-btn-purple" @click="closeDialog">סגור</button>
            <button class="yoga-btn-beige" v-if="type === 2"
            @click="changeAccountType">עבור למנוי חודשי</button>
            <button class="yoga-btn-beige" v-if="type === 1"
            @click="changeAccountType">עבור למנוי שנתי</button>
          </div>

          <div v-else>
            <h2 class="has-text-success">{{message.text}}</h2>
            <p>{{message.desc}}</p>
            <button class="yoga-btn-purple" @click="closeDialog">סגור</button>
          </div>
        </div>
      </div>
      <button class="modal-close is-large" aria-label="close"
      @click="closeDialog"></button>
    </div>
</template>

<script>
export default {
  data() {
    return {
      message: {
        visible: false,
        text: ``,
        desc: ``,
        price: ``
      }
    };
  },
  methods: {
    closeDialog() {
      this.$emit(`close-dialog`);
    },
    changeAccountType() {
      this.$store.dispatch(`changeAccountType`, this.type).then((price) => {
        this.message.price = price;
        this.showMessage();
      });
    },
    showMessage() {
      this.message.visible = true;
      if (this.type === 1) {
        this.message.text = `המנוי הועבר למסלול חודשי.`;
        this.message.desc = `חשבונך יחוייב בתאריך התשלום הבא ב${
          this.message.price
        } ש"ח`;
      }
      if (this.type === 2) {
        this.message.text = `המנוי הועבר למסלול שנתי.`;
        this.message.desc = `חשבונך יחוייב בתאריך התשלום הבא ב${
          this.message.price
        } ש"ח`;
      }
    }
  },

  computed: {
    type() {
      const sub = this.$store.state.user.subType;

      if (parseInt(sub, 10) === 2) {
        // to year
        return 2;
      }
      return 1;
    }
  }
};
</script>

<style lang="scss">
.account-type-dialog {
  .box {
    text-align: center;
  }
  h3 {
    font-size: 1.2rem;
  }

  .yoga-btn-beige {
    margin-right: 5px;
  }
}
</style>
